/* eslint no-tabs: 0 */

const BLOCK_TYPE = {
    ATOMIC: 'atomic',
    CODE: 'code-block',
    H1: 'header-one',
    H2: 'header-two',
    H3: 'header-three',
    HR: 'hr',
    LIST: 'ordered-list-item',
    ORDERED_LIST: 'ordered-list-item',
    UNORDERED_LIST: 'unordered-list-item',
    UNSTYLED: 'unstyled',
    TABLE: 'table',
    CALLOUT: 'callout',
};

const CALLOUT_COLORS = {
    yellow: 'yellow',
    red: 'red',
    green: 'green',
    blue: 'blue',
    orange: 'orange',
    purple: 'purple',
    grey: 'grey',
};

const COMMAND = {
    moveSelectionUp: 'move-selection-up',
    automarkdownOrderedList: 'automarkdown-ordered-list-item',
    automarkdownUnorderedList: 'automarkdown-unordered-list-item',
    automarkdownHeaderOne: 'automarkdown-header-one',
    automarkdownHeaderTwo: 'automarkdown-header-two',
    automarkdownHeaderThree: 'automarkdown-header-three',
    automarkdownCode: 'automarkdown-code-block',
    automarkdownHR: 'automarkdown-hr',
    insertGithubIssue: 'insert-github-issue',
    insertInlineReference: 'insert-inline-reference',
    insertGoogleDriveDoc: 'insert-google-drive-doc',
    delete: 'delete',
    backspace: 'backspace',
    insertSuggestion: 'insert-suggestion',
    insertMention: 'insert-mention',
    insertPageReference: 'insert-page-reference',
    toggleBlockType: 'toggle-block-type',
    showLinkDialog: 'show-link-dialog',
    undo: 'undo',
    redo: 'redo',
    toggleOrderedList: 'toggle-ordered-list-item',
    toggleUnorderedList: 'toggle-unordered-list-item',
    toggleHeaderOne: 'toggle-header-one',
    toggleHeaderTwo: 'toggle-header-two',
    toggleHeaderThree: 'toggle-header-three',
    toggleInlineFormatStrikethrough: 'inline-format-strikethrough',
    toggleInlineFormatHighlight: 'inline-format-highlight',
    toggleInlineFormatCode: 'inline-format-code',
};

const EMBEDLY_TYPE = {
    LINK: 'link',
    PHOTO: 'photo',
    RICH: 'rich',
    VIDEO: 'video',
};

const HEADER_TAGS = {
    'header-one': 'h1',
    'header-two': 'h2',
    'header-three': 'h3',
    'header-four': 'h4',
    'header-five': 'h5',
};

const ENTITY_TYPE = {
    AUDIO: 'AUDIO',
    EMBEDLY: 'EMBEDLY',
    FILE: 'FILE',
    GITHUB_ISSUE: 'GITHUB-ISSUE',
    GOOGLE_DOC: 'GOOGLE-DOC',
    HR: 'HR',
    IFRAME: 'IFRAME',
    IMAGE: 'IMAGE',
    INLINE_REFERENCE: 'INLINE-REFERENCE',
    LINK: 'LINK',
    MENTION: 'MENTION',
    PAGE_REFERENCE: 'PAGE-REFERENCE',
    TABLE: 'TABLE',
    VIDEO: 'VIDEO',
};

// Inline references are an internal classification of Draft Entities and have their own subtypes (`entity.data.type`)
// For more info on inline references, see https://staging.tettra.co/teams/tettra/pages/inline-reference-entities
// NOTE: moving forward will use RESOURCE_TYPE in ../constants.js
const INLINE_REFERENCE_TYPE = {
    GITHUB_ISSUE: 'GITHUB-ISSUE',
    PAGE_REFERENCE: 'PAGE-REFERENCE',
    GOOGLE_DOC: 'GOOGLE-DOC',
    MENTION: 'MENTION',
};

// Unicode characters copy/pasted from autogenerated comments in custom "Redstone" font icon files
// May not render in your IDE. See `resources/assets/icon-font/css/redstone.css`
const FONT_ICON = {
    GITHUB: '',
    DOCUMENT: '',
    FILE: '',
    GOOGLE_DOCS: '',
    GOOGLE_DRAWING: '',
    GOOGLE_SLIDES: '',
    GOOGLE_SHEETS: '',
    GOOGLE_FORMS: '',
    GOOGLE_DRIVE_DEFAULT: '',
    TETTRA_QUESTION: '',
    NOTION: '',
};

const KEY = {
    arrowUp: 'ArrowUp',
    arrowDown: 'ArrowDown',
    enter: 'Enter',
    escape: 'Escape',
    backspace: 'Backspace',
    tab: 'Tab',
    forwardSlash: '/',
    k: 'k'
};

const REMOVAL = {
    backwards: 'backwards',
    forwards: 'forwards',
};

const KEYCODE = {
    enter: 13,
    escape: 27,
    space: 32,
    tab: 9,
    leftArrow: 37,
    upArrow: 38,
    rightArrow: 39,
    downArrow: 40,
    one: 49,
    two: 50,
    three: 51,
    seven: 55,
    eight: 56,
    e: 69,
    k: 75,
    x: 88,
};

const IMMUTABLE = 'IMMUTABLE';

const MUTABLE = 'MUTABLE';

const HANDLED = 'handled';

const NOT_HANDLED = 'not-handled';

/**
 *  Draft.js InlineStyles available for user selection in the editor
 */
const STYLE = {
    BOLD: 'BOLD',
    ITALIC: 'ITALIC',
    UNDERLINE: 'UNDERLINE',
    STRIKETHROUGH: 'STRIKETHROUGH',
    HIGHLIGHT: 'HIGHLIGHT',
    CODE: 'CODE',
};

const SUGGESTION_TRIGGERS = {
    MENTION: '@',
    INTERNAL: '+',
    EXTERNAL: '#',
};

/**
 *  Draft.js InlineStyles intended for "private" use (should not be applied manually in editor)
 */
const STYLE_AUTO = {
    FONT_ICON: 'FONT_ICON',
};

const PLACEHOLDER = 'Type your text...';

const FOUR_SPACES = '    ';

const TAB_CHARACTER = FOUR_SPACES;

const TAB_MAX_DEPTH = 4;

const DOC_WIDTH = 768;

const IFRAME_HEIGHT = 800;

const DATABOX_IFRAME_HEIGHT = 450;

export {
    BLOCK_TYPE,
    COMMAND,
    CALLOUT_COLORS,
    EMBEDLY_TYPE,
    ENTITY_TYPE,
    INLINE_REFERENCE_TYPE,
    FONT_ICON,
    KEY,
    KEYCODE,
    IMMUTABLE,
    MUTABLE,
    HANDLED,
    PLACEHOLDER,
    NOT_HANDLED,
    STYLE,
    STYLE_AUTO,
    SUGGESTION_TRIGGERS,
    TAB_CHARACTER,
    TAB_MAX_DEPTH,
    REMOVAL,
    DOC_WIDTH,
    IFRAME_HEIGHT,
    DATABOX_IFRAME_HEIGHT,
    FOUR_SPACES,
    HEADER_TAGS,
};
